<template>
  <div class="cgu">
    <el-checkbox v-model="model">
      <span>{{ $t('resume.preBooking.cguAcceptation') }} </span>
      <el-link
        type="primary"
        class="cgu__link"
        :href="$t('resume.preBooking.cguLink')"
        target="_blank">
        {{ $t('resume.preBooking.cguLabel') }}
      </el-link>
    </el-checkbox>
    <div :class="[{'invisible': model || !showError}, 'cgu__error']">
      {{ $t('resume.preBooking.cguError') }}
    </div>
  </div>
</template>

<script>
import Input from '@nextories/vue-core-components/src/components/atoms/input/Input.vue';

export default {
  name: 'cgu',
  extends: Input,
  props: {
    showError: Boolean,
  },
};
</script>

<style scoped lang="scss">
.cgu {
  margin-top: 20px;
  font-size: 15px;

  :deep(.el-checkbox__label) {
    white-space: normal;
    font-size: 15px;
  }

  &__link {
    display: inline;
  }

  &__error {
    color: var( --nxt-color-warning);

    &.invisible {
      visibility: hidden;
    }
  }
}
</style>
